module.exports = __webpack_public_path__ + "static/img/donation.f3932ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/master/donation.png
// module id = 0wuI
// module chunks = 1